export const einRegExp = /^\d{2}-?\d{7}$/;
export const zipRegExp = /^\d{5}(-\d{4})?$/;
export const phoneRegExp = /^[2-9]\d{2}[-]?\d{3}[-]?\d{4}$/;
export const urlRegExp = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;
export const passwordRegExp = /^(?=.*[A-Z])(?=.*\d).*$/;
// export const POBoxRegExp = ?;
